const cacheKeys = {
  all: ['contracts'],
  list: () => [...cacheKeys.all, 'list']
}

export default {
  endpoints: {
    contracts: '/contracts',
    accept: '/contracts/accept'
  },
  cacheKeys
}
